import { Box } from '@mui/material';
import { ApexOptions } from 'apexcharts';
import { Icon } from 'components';
import { observer } from 'mobx-react';
import React from 'react';
import Chart from "react-apexcharts";
import ReactDOMServer from 'react-dom/server';
import { useTranslation } from 'react-i18next';
import { Tree } from 'stores';
import { ApexChartParams, IChartProps, TreeContext } from 'views';

export interface IStatusChartProps extends IChartProps {
  showData: boolean;
};

export const StatusChart = observer((props: IStatusChartProps): JSX.Element => {
  const { preview, showData } = props;
  const { t }       = useTranslation();
  const tree: Tree  = React.useContext(TreeContext);

  const previewData: ApexAxisChartSeries = [
    {
      name: t("not_started"),
      data: [44, 55, 41, 64]
    },{
      name: t("active"),
      data: [31, 25, 71, 54]
    },{
      name: t("completed"),
      data: [42, 35, 45, 94]
    },
  ];

  const previewLabels: string[] = ["Company A", "Company B", "Company C", "Company D"];

  const { data, labels } : {data: ApexAxisChartSeries, labels: string[]} = 
  preview ? {data: previewData, labels: previewLabels} : tree.getChartData('status');
  
  const options: ApexOptions = {
    noData: {
      text: t("no_chart_data"),
    },
    dataLabels: {
      enabled: !preview,
      style: {
        colors: [
          function (params: ApexChartParams) {
            if (params.series[params.seriesIndex][params.dataPointIndex] === 0 ) {
              return "black"; 
            } else {
              return "white"; 
            }
          },
        ],
      }
    },
    chart: {
      id:      t('status_chart_title'),
      width:   "100%",
      height:  "100%",
      toolbar: {
        show: !preview,
        tools: {
          download: ReactDOMServer.renderToString(<Icon size='size-18' iconId='download' />),
        },
        export: {
          csv: {
            filename: t('status_chart_title'),
            headerCategory: t('status'),
            columnDelimiter: ";"
          },
          svg: { 
            filename: t('status_chart_title'),
          },
          png: { 
            filename: t('status_chart_title'),
          },
        },
      },
    },
    colors: ['#007672', '#00AB84', '#c6007e', '#833177','#FF7500'],
    tooltip: {
      enabled: !preview,
    },
    title: {
      text: t('status_chart_title'),
    },
    subtitle: {
      text:  preview ? '' : tree.hierarchy.map(h => t(h)).join('/ '),
      align: 'center',
    },
    plotOptions: {
      bar: {
        horizontal: true,
      },
    },
    states: {
      hover: {
        filter: {
          type: preview ? 'none' : undefined,
        },
      },
    },
    xaxis: {
      categories: labels,
      labels: {
        trim: true,
        hideOverlappingLabels: true,
        show: Boolean(labels?.length)
      },
    },
    yaxis: {
      labels: {
        show: Boolean(labels?.length)
      },
    }
  };

  return (
    <Box height="100%" width="100%"> {/* Chart needs a not flex container to stretch as expected */}
      <Chart
        type    = "bar"
        series  = {data}
        options = {options}
        width   = "100%"
        height  = "100%"
      />
    </Box>
  );
});